<template>
  <div class="tableContainer expansion">
    <div class="list">
      <md-list md-expanded :md-expand="expandClients">
        <md-list-item :md-expanded="client.openBrands" md-expand v-for="client in clients" :key="client.client_id">
          <router-link :to="'/client/'+client.slug">
           
            <div class="md-list-item-text ">
              {{ client.name }}
            </div>
          </router-link>

          <md-list slot="md-expand" class="itemList">
            <md-list-item v-for="brand in client.brand" :key="brand.id"
                          class="itemContainerBright"
                          :to="{ path: '/brand/'+brand.slug}"
            >
              <div>
                <img :srcset="brand.logo.srcset" class="brandLogo"/>
                <span class="brandname">{{ brand.name }}</span>
              </div>
              <img alt="Arrow Icon" class="iconButton arrowIcon" src="@/assets/img/icons/arrow-right.svg"/>
            </md-list-item>
           
            <addNewBrand  :refreshClient="refreshBrand" :client="client"/>
          </md-list>

        </md-list-item>
      </md-list>
    </div>
  </div>
</template>

<script>
import addNewBrand from "@/components/pagesComponents/dashboard/addNewBrand.vue"

export default {
  props: ['clients'],
  components: {
    addNewBrand
  },
  data() {
    return {
      expandClients: true
    }
  },
  methods: {
    refreshBrand() {
      let _this = this
      console.log('refreshBrand expansion')
      if (_this.$parent.refreshClients)
        _this.$parent.refreshClients()
    }
  }
}
</script>
